// extracted by mini-css-extract-plugin
export default {"wrapper":"ParticipantSelect_wrapper__fH6KU"};